import type { CmsLinkModel } from "#/_packages/umbrella/integrations/umbraco/types/cms-link";

/** Keep the CMS path, query and anchor in the router's separate typed fields. */
export function buttonLinkDestination(link: CmsLinkModel) {
	const path = new URL(link.route?.path ?? "/", "https://cms-link.invalid");
	const query = link.queryString ?? link.route?.queryString;
	if (query) {
		const suffix = new URL(
			query.startsWith("?") || query.startsWith("#") ? query : `?${query}`,
			path,
		);
		path.search = suffix.search;
		path.hash = suffix.hash;
	}
	const search: Record<string, string | string[]> = Object.create(null);
	for (const key of new Set(path.searchParams.keys())) {
		const values = path.searchParams.getAll(key);
		search[key] = values.length === 1 ? values[0] : values;
	}
	return {
		params: { _splat: path.pathname },
		search,
		hash: path.hash.slice(1),
	};
}
